import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, GoogleAuthProvider, setPersistence, browserLocalPersistence } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
    apiKey: "AIzaSyB9Pwk7wpDaigc04rG8ESZnowwOyFaKi3s",
    authDomain: "myprofilecorner-c8a7c.firebaseapp.com",
    projectId: "myprofilecorner-c8a7c",
    storageBucket: "myprofilecorner-c8a7c.firebasestorage.app",
    messagingSenderId: "246270337551",
    appId: "1:246270337551:web:cc0cdb9b3dcc5c1edbb97a",
    measurementId: "G-ZLKR026JBW"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();

// Keep user logged in permanently via localStorage (survives tab/browser close)
setPersistence(auth, browserLocalPersistence).catch(() => {});

export const storage = getStorage(app);
export { auth, provider };

export default db;
